import base64 from "base-64";
import omit from "lodash/omit";
import { NextRouter } from "next/router";
import { DEFAULT_PAGE } from "./constants";
import { IProductsSearchCriteria, IProductsFilterState } from "./types";

export const getCountOfSelectedFilterValues = (
  selectedFilterValues?: IProductsFilterState["selectedFilterValues"]
) => {
  if (!selectedFilterValues || !Object.keys(selectedFilterValues).length) {
    return 0;
  }

  return Object.values(selectedFilterValues).reduce((acc, curr) => {
    return acc + curr.length;
  }, 0);
};

export const encodeProductsSearchCriteria = (
  searchCriteria: IProductsSearchCriteria
): string => base64.encode(JSON.stringify(searchCriteria));

export const decodeProductsSearchCriteria = (
  encodedStr: string
): IProductsSearchCriteria => JSON.parse(base64.decode(encodedStr));

export const updateProductsSearchCriteriaBySelectedFilter = (
  searchCriteria: IProductsSearchCriteria,
  category: string,
  value: string,
  isCheckBoxFilter?: boolean
): IProductsSearchCriteria => {
  const prevSearchCriteriaFilterValues =
    searchCriteria?.filterBy?.[category] ?? [];

  const handleFilterUpdate = () => {
    if (prevSearchCriteriaFilterValues.includes(value)) {
      return value.includes("custom")
        ? [value]
        : prevSearchCriteriaFilterValues.filter(
            (item: string) => item !== value
          );
    } else {
      return isCheckBoxFilter
        ? prevSearchCriteriaFilterValues.concat(value)
        : [value];
    }
  };

  return {
    ...searchCriteria,
    page: DEFAULT_PAGE,
    filterBy: {
      ...(searchCriteria?.filterBy ?? {}),
      [category]: handleFilterUpdate(),
    },
  };
};

export const changeProductsSearchCriteriaInURL = (
  router: NextRouter,
  searchCriteria: IProductsSearchCriteria | null
) => {
  if (!searchCriteria) {
    const queryWithoutCriteria = omit(router.query, ["criteria"]);

    return router.replace({ query: queryWithoutCriteria }, undefined, {
      shallow: true,
    });
  }

  return router.replace(
    {
      query: {
        ...router.query,
        criteria: encodeProductsSearchCriteria(searchCriteria),
      },
    },
    undefined,
    { shallow: true }
  );
};
